import React from "react"

export default function Error() {

    return (
        <div>
            <h1>404 Page not found</h1>
            <img src="https://static.vecteezy.com/system/resources/previews/004/441/392/non_2x/young-woman-reading-an-interesting-book-at-home-cartoon-illustration-isolated-on-white-background-vector.jpg" alt="" />
        </div>

    )
}